import { defineCopy } from '../pageCopy';

const en = {
  meta: {
    title: 'Support',
    description:
      'Get support for DataCode products and services. Contact our team for help with mobile apps, web development, and AI integration.',
    ogTitle: 'Support | Datacode',
    ogDescription: 'Get support for DataCode products and services. Contact our team for assistance.',
  },
  hero: {
    eyebrow: 'Help Center',
    title: 'SUPPORT',
    subtitle:
      "Need help with one of our products or services? We're here to assist you. Submit a support request and our team will get back to you as soon as possible.",
    scroll: 'Scroll to Explore',
    getHelp: 'Get Help',
  },
  quick: {
    eyebrow: 'How Can We Help?',
    title: 'QUICK HELP',
    emailTitle: 'Email Support',
    emailBody: 'Get help via email within 24 hours',
    docsTitle: 'Documentation',
    docsBody: 'Browse our guides and tutorials',
    docsSoon: 'Coming Soon',
    phoneTitle: 'Phone Support',
    phoneBody: 'Call us during business hours',
  },
  formSection: {
    title: 'GET HELP',
    intro: 'Fill out the form and our support team will respond within 24 hours.',
  },
  cta: {
    eyebrow: 'Need More Help?',
    title: 'Contact Us',
  },
  form: {
    namePlaceholder: "What's Your Name",
    emailPlaceholder: 'Your E-mail',
    messagePlaceholder: 'Describe your issue or question',
    submit: 'Submit Request',
    sending: 'Sending...',
    success: "Thank you! Your support request has been submitted. We'll get back to you within 24 hours.",
    error: 'Something went wrong. Please try again or email us directly at {email}',
    validation: {
      nameMin: 'Name must be at least 2 characters',
      emailInvalid: 'Please enter a valid email',
      productRequired: 'Please select a product',
      messageMin: 'Message must be at least 10 characters',
    },
    products: {
      placeholder: 'Select a Product/Service',
      akooIraq: 'Akoo Iraq',
      krgCalendar: 'KRG Calendar',
      exchangeProgrammes: 'Exchange Programmes',
      datacodeRms: 'DataCode RMS',
      taakline: 'Taakline',
      zubene: 'Zubene',
      tamam: 'Tamam',
      trendz: 'Trendz',
      webDevelopment: 'Web Development',
      mobileApp: 'Mobile App Development',
      aiIntegration: 'AI Integration',
      other: 'Other',
    },
  },
};

const ar: typeof en = {
  meta: {
    title: 'الدعم',
    description:
      'احصل على الدعم لمنتجات وخدمات Datacode. تواصل ويا فريقنا للمساعدة بتطبيقات الموبايل وتطوير المواقع ودمج الذكاء الاصطناعي.',
    ogTitle: 'الدعم | Datacode',
    ogDescription: 'احصل على الدعم لمنتجات وخدمات Datacode. تواصل ويا فريقنا للمساعدة.',
  },
  hero: {
    eyebrow: 'مركز المساعدة',
    title: 'الدعم',
    subtitle:
      'تحتاج مساعدة بأحد منتجاتنا أو خدماتنا؟ احنا موجودين نساعدك. ارسل طلب دعم وفريقنا يرد عليك بأسرع وقت ممكن.',
    scroll: 'اسحب لتشوف أكثر',
    getHelp: 'اطلب مساعدة',
  },
  quick: {
    eyebrow: 'شلون نكدر نساعدك؟',
    title: 'مساعدة سريعة',
    emailTitle: 'الدعم بالبريد الإلكتروني',
    emailBody: 'نرد عليك بالبريد خلال 24 ساعة',
    docsTitle: 'التوثيق',
    docsBody: 'تصفح أدلتنا وشروحاتنا',
    docsSoon: 'قريباً',
    phoneTitle: 'الدعم الهاتفي',
    phoneBody: 'اتصل بينا خلال ساعات الدوام',
  },
  formSection: {
    title: 'اطلب مساعدة',
    intro: 'عبّي النموذج وفريق الدعم يرد عليك خلال 24 ساعة.',
  },
  cta: {
    eyebrow: 'تحتاج مساعدة أكثر؟',
    title: 'تواصل معنا',
  },
  form: {
    namePlaceholder: 'شنو اسمك؟',
    emailPlaceholder: 'بريدك الإلكتروني',
    messagePlaceholder: 'اشرح مشكلتك أو سؤالك',
    submit: 'إرسال الطلب',
    sending: 'جاري الإرسال...',
    success: 'شكراً! وصلنا طلب الدعم، راح نرد عليك خلال 24 ساعة.',
    error: 'صار خطأ. حاول مرة ثانية أو راسلنا مباشرة على {email}',
    validation: {
      nameMin: 'الاسم لازم يكون حرفين على الأقل',
      emailInvalid: 'الرجاء إدخال بريد إلكتروني صحيح',
      productRequired: 'الرجاء اختيار منتج',
      messageMin: 'الرسالة لازم تكون 10 أحرف على الأقل',
    },
    products: {
      placeholder: 'اختر المنتج أو الخدمة',
      akooIraq: 'Akoo Iraq',
      krgCalendar: 'تقويم KRG',
      exchangeProgrammes: 'برامج التبادل',
      datacodeRms: 'DataCode RMS',
      taakline: 'Taakline',
      zubene: 'Zubene',
      tamam: 'Tamam',
      trendz: 'Trendz',
      webDevelopment: 'تطوير المواقع',
      mobileApp: 'تطوير تطبيقات الموبايل',
      aiIntegration: 'دمج الذكاء الاصطناعي',
      other: 'أخرى',
    },
  },
};

const ckb: typeof en = {
  meta: {
    title: 'پشتگیری',
    description:
      'پشتگیری وەربگرە بۆ بەرهەم و خزمەتگوزارییەکانی Datacode. پەیوەندی بە تیمەکەمانەوە بکە بۆ یارمەتی لە ئەپی مۆبایل، گەشەپێدانی وێبسایت و تێکەڵکردنی زیرەکی دەستکرد.',
    ogTitle: 'پشتگیری | Datacode',
    ogDescription: 'پشتگیری وەربگرە بۆ بەرهەم و خزمەتگوزارییەکانی Datacode. پەیوەندی بە تیمەکەمانەوە بکە بۆ یارمەتی.',
  },
  hero: {
    eyebrow: 'ناوەندی یارمەتی',
    title: 'پشتگیری',
    subtitle:
      'یارمەتیت دەوێت لەگەڵ یەکێک لە بەرهەم یان خزمەتگوزارییەکانمان؟ ئێمە لێرەین بۆ یارمەتیدانت. داواکارییەکی پشتگیری بنێرە و تیمەکەمان بە زووترین کات وەڵامت دەداتەوە.',
    scroll: 'بۆ خوارەوە بڕۆ',
    getHelp: 'داوای یارمەتی بکە',
  },
  quick: {
    eyebrow: 'چۆن یارمەتیت بدەین؟',
    title: 'یارمەتی خێرا',
    emailTitle: 'پشتگیری بە ئیمەیل',
    emailBody: 'لە ماوەی 24 کاتژمێردا بە ئیمەیل وەڵامت دەدەینەوە',
    docsTitle: 'بەڵگەنامە',
    docsBody: 'ڕێنمایی و فێرکارییەکانمان بگەڕێ',
    docsSoon: 'بەم زووانە',
    phoneTitle: 'پشتگیری بە تەلەفۆن',
    phoneBody: 'لە کاتی دەوامدا پەیوەندیمان پێوە بکە',
  },
  formSection: {
    title: 'داوای یارمەتی',
    intro: 'فۆڕمەکە پڕ بکەرەوە و تیمی پشتگیریمان لە ماوەی 24 کاتژمێردا وەڵامت دەداتەوە.',
  },
  cta: {
    eyebrow: 'یارمەتی زیاترت دەوێت؟',
    title: 'پەیوەندیمان پێوە بکە',
  },
  form: {
    namePlaceholder: 'ناوت چییە؟',
    emailPlaceholder: 'ئیمەیلەکەت',
    messagePlaceholder: 'کێشە یان پرسیارەکەت شی بکەرەوە',
    submit: 'ناردنی داواکاری',
    sending: 'دەنێردرێت...',
    success: 'سوپاس! داواکارییەکەت گەیشت، لە ماوەی 24 کاتژمێردا وەڵامت دەدەینەوە.',
    error: 'هەڵەیەک ڕوویدا. تکایە دووبارە هەوڵ بدەرەوە یان ڕاستەوخۆ ئیمەیلمان بۆ بنێرە: {email}',
    validation: {
      nameMin: 'ناو دەبێت لانیکەم 2 پیت بێت',
      emailInvalid: 'تکایە ئیمەیلێکی دروست بنووسە',
      productRequired: 'تکایە بەرهەمێک هەڵبژێرە',
      messageMin: 'پەیام دەبێت لانیکەم 10 پیت بێت',
    },
    products: {
      placeholder: 'بەرهەم یان خزمەتگوزارییەک هەڵبژێرە',
      akooIraq: 'Akoo Iraq',
      krgCalendar: 'ساڵنامەی KRG',
      exchangeProgrammes: 'بەرنامەکانی ئاڵوگۆڕ',
      datacodeRms: 'DataCode RMS',
      taakline: 'Taakline',
      zubene: 'Zubene',
      tamam: 'Tamam',
      trendz: 'Trendz',
      webDevelopment: 'گەشەپێدانی وێبسایت',
      mobileApp: 'گەشەپێدانی ئەپی مۆبایل',
      aiIntegration: 'تێکەڵکردنی زیرەکی دەستکرد',
      other: 'هی تر',
    },
  },
};

export const supportCopy = defineCopy(en, ar, ckb);

/** Product option values, in display order. `label` keys into `form.products`. */
export const SUPPORT_PRODUCT_OPTIONS = [
  { value: 'akoo-iraq', key: 'akooIraq' },
  { value: 'krg-calendar', key: 'krgCalendar' },
  { value: 'exchange-programmes', key: 'exchangeProgrammes' },
  { value: 'datacode-rms', key: 'datacodeRms' },
  { value: 'taakline', key: 'taakline' },
  { value: 'zubene', key: 'zubene' },
  { value: 'tamam', key: 'tamam' },
  { value: 'trendz', key: 'trendz' },
  { value: 'web-development', key: 'webDevelopment' },
  { value: 'mobile-app', key: 'mobileApp' },
  { value: 'ai-integration', key: 'aiIntegration' },
  { value: 'other', key: 'other' },
] as const;
